{
  "aria-label": "Лейбл кнопки"
}
